// extracted by mini-css-extract-plugin
module.exports = {"volume":"audio-volume_volume__iBZUS","slider":"audio-volume_slider__nkDz2"};